import "core-js/modules/es6.object.assign";
import _regeneratorRuntime from "@babel/runtime/regenerator";
import "regenerator-runtime/runtime";
import "core-js/modules/es6.promise";
import "core-js/modules/es6.object.to-string";

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }

function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }

var API_URL = '/.netlify/functions';
var DEFAULT_RETRIES = 3;
export var getStatus = function getStatus(status, ok, data) {
  return {
    status: status,
    ok: ok,
    data: data
  };
};
export var parseJSON = function parseJSON(response) {
  var ok = response.ok,
      status = response.status,
      statusText = response.statusText;
  return new Promise(
  /*#__PURE__*/
  function () {
    var _ref = _asyncToGenerator(
    /*#__PURE__*/
    _regeneratorRuntime.mark(function _callee(resolve) {
      var json;
      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              if (!(status === 200)) {
                _context.next = 5;
                break;
              }

              _context.next = 3;
              return response.json();

            case 3:
              json = _context.sent;
              return _context.abrupt("return", resolve(getStatus(status, ok, json)));

            case 5:
              return _context.abrupt("return", resolve(getStatus(status, false, statusText)));

            case 6:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }));

    return function (_x) {
      return _ref.apply(this, arguments);
    };
  }());
};

var fetchWithRetry = function fetchWithRetry(url, options, tries) {
  return new Promise(
  /*#__PURE__*/
  function () {
    var _ref2 = _asyncToGenerator(
    /*#__PURE__*/
    _regeneratorRuntime.mark(function _callee2(resolve, reject) {
      var body, res, data;
      return _regeneratorRuntime.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              _context2.next = 2;
              return fetch(url, options);

            case 2:
              body = _context2.sent;
              _context2.next = 5;
              return parseJSON(body);

            case 5:
              res = _context2.sent;

              if (res.ok) {
                resolve(res.data);
              } else if (tries === 1) {
                reject(res);
              } else {
                try {
                  data = fetchWithRetry(url, options, tries - 1);
                  resolve(data);
                } catch (error) {
                  reject(error);
                }
              }

            case 7:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2);
    }));

    return function (_x2, _x3) {
      return _ref2.apply(this, arguments);
    };
  }());
};

export default (function (endpoint, method, options) {
  if (method === void 0) {
    method = 'GET';
  }

  if (options === void 0) {
    options = {};
  }

  var fetchOptions = Object.assign({}, options, {
    method: method,
    headers: {
      'Content-Type': 'application/json'
    }
  });
  return fetchWithRetry(API_URL + endpoint, fetchOptions, DEFAULT_RETRIES);
});